import g from '#core/global';
import load from '#core/load';


const target_attr = 'aria-controls';
const is_expanded_attr = 'aria-expanded';
const abstract_text_c = 'network-card__abstract__text';
const abstract_text_$ = `.${abstract_text_c}`;
const abstract_button_$ = '.network-card__abstract-button';

let has_network_card = false;
let $tabs = [];


const module = {
	
	/**
	 * Init module
	 */
	init() {
		if (load.ran('network-card')) return false;
		
		load.content(() => {
			has_network_card = assign_elements();
			if (!has_network_card) return false;
		});
		load.all(() => {
			has_network_card = assign_elements();
			if (!has_network_card) return false;
		});
	},
	
	
	/**
	 * Set visibility of buttons based on length of content
	 */
	setButtonVisibility() {
		set_button_visibility();
	},
	
};

export default module;
module.init();


/**
 * Assign elements and event listeners
 * @return {boolean}
 */
function assign_elements() {
	if (has_network_card) return true;
	
	document.addEventListener(g.click_e, e => {
		const $button = e.target.closest(abstract_button_$);
		if (!$button) return;
		
		e.preventDefault();
		toggle_content($button);
	});
	
	return true;
}


/**
 * Toggle content visibility
 * @param {element} $button
 */
function toggle_content($button) {
	// const $content = document.querySelector(`#${$button.getAttribute(target_attr)}`);
	
	if ($button.getAttribute(is_expanded_attr) === g.false_s) {
		$button.setAttribute(is_expanded_attr, g.true_s);
	} else {
		$button.setAttribute(is_expanded_attr, g.false_s);
	}
}


/**
 * Set visibility of buttons based on length of content
 */
function set_button_visibility() {
	const $abstract_texts = document.querySelectorAll(abstract_text_$);
	
	$abstract_texts.forEach($text => {
		const is_long = $text.scrollHeight > $text.clientHeight;
		$text.classList.add(`${abstract_text_c}--${is_long ? 'long' : 'short'}`);
	});
}
